import styles from "@/styles/reset-password/index.module.scss"
import Head from "next/head"
import LoginLayout from "@/components/LoginLayout"
import Image from 'next/image'
import Link from 'next/link'
import { Button, Form, Input, message } from 'antd'
import NewsletterIcon from "@/svgs/newsletter.svg"
import { useState } from "react"
import productApi from '@/service/modules/productApi'
import resetPasswordApi from '@/service/modules/resetPasswordApi'

export default function ResetPassword() {

  const [form] = Form.useForm()
  const [isSendEmail, setIsSendEmail] = useState(false)
  const [email, setEmail] = useState(false)

  const defaultCaptcha = {
    img: "",
    key: ""
  }
  const [captcha, setCaptcha] = useState(defaultCaptcha)

  // 切换上一页/下一页
  const generateCaptchaImage = async () => {
    try {
      const res = await productApi.generate()
      const { captcha } = res.data
      setCaptcha(captcha)

    } catch (error: any) {
      message.error(error.message)
    }
  }

  // 校验成功，发起提交请求
  const onFinish = async(values: any) => {
    try {
      let dataObj = {
        email: values.email,
        captcha: '',
        key: ''
      }

      if (captcha.img) {
        dataObj.captcha = values.captchaCode
        dataObj.key = captcha.key
      }

      const finnalParams = Object.fromEntries(
        Object.entries(dataObj).filter(([_, value]) => value !== null && value !== '')
      );

      let res = await resetPasswordApi.forgotPassword(finnalParams)
      if (res.data) {
        setIsSendEmail(true)
        setEmail(values.email)
      }
    } catch (error: any) {
      // message.error(error.message)

      /* 处理错误信息 
        - 假设API错误的返回格式为：{ message: '错误信息', field: '表单字段名' }
        - 你需要根据你实际的错误响应结构来调整
      */

      if (error.message) {
        if (error.code == 110000) {
          // captchaCode输入错误
          const errorMessage = error.message
          const errorField = 'captchaCode'
          
          form.setFields([
            {
              name: errorField,
              errors: [errorMessage],
            }
          ]);
        } else {
          // 超过三次失误，请求captchaCode
          const errorMessage = error.message
          const errorField = 'email'
          
          form.setFields([
            {
              name: errorField,
              errors: [errorMessage],
            }
          ]);
        }

        // 只要code返回不是100111(账户未注册), 都展开验证码输入
        if (error.code != 100111) {
          generateCaptchaImage()
        }

      } else {
        // 如果不是一个有效的数据响应，你可以设置一个通用的错误信息
        message.error('An unexpected error occurred. Please try again.');
      }
    }
  }

  // Resend Password, 页面刷新即可
  const handleResendPassword = async () => {
    // location.reload()
    setIsSendEmail(false)
  }

  return (
    <>
      <Head>
        <title>
          Online Shopping in New Zealand: Discount Store - BestDeals.co.nz
        </title>
        <meta
          name="keywords"
          content=""
        ></meta>
        <meta 
          name="description" 
          content="Offers the best online shopping in New Zealand with cheap deals on home & garden, appliances, pet supplies, fitness equipment & much more online. Check out our daily sales now!"
        ></meta>
      </Head>

      <LoginLayout>
        <div className={styles['page-reset-password']}>

          {
            isSendEmail
            ?
            <div className={styles['send-email-box']}>
              <div className={styles['title-icon']}>
                <NewsletterIcon style={{ width: '50px', textAlign: 'center' }}></NewsletterIcon>
              </div>
              <div className={styles['title']}>Check Your Email</div>
              <div className={styles['desc']} style={{ textAlign: 'center' }}>
                We’ve sent an email to <span className={styles['email-text']}>{email}</span>  with instructions on how to reset your password. <br/>
                Please check your email inbox and follow the simple instructions to reset your password.
              </div>

              <Button 
                className={styles['save-btn']}
                onClick={handleResendPassword}
              >
                Resend Email
              </Button>

              <div className={styles['back-to-sign']}>
                Back to
                <Link
                  href={'/login'}
                  legacyBehavior
                >
                  <a className={styles['link']} rel="noopener noreferrer">Sign in</a>
                </Link>
              </div>
            </div>
            :
            <div className={styles['email-form-box']}>
              <div className={styles['title']}>Forgot Password?</div>
              <div className={styles['desc']}>Enter your email address and click Reset Password. We’ll send you an email to create a new password.</div>

              <Form
                name="basic"
                layout="vertical"
                size={'large'}
                style={{ width: '100%' }}
                form={form}
                onFinish={onFinish}
                autoComplete="off"
                scrollToFirstError
              >
                <Form.Item
                  name="email"
                  rules={[
                    { required: true, message: `Error! Email can’t be empty.`},
                    { type: 'email', message: `Invalid Email Address`},
                  ]}
                >
                  <Input placeholder="Login Email" maxLength={225} />
                </Form.Item>

                {
                  !!captcha.img &&
                  <div className={styles['verification-box']}>
                    <Form.Item
                      name="captchaCode"
                      rules={[
                        { required: true, message: `Verification Code can’t be empty.`}
                      ]}
                      style={{ width: '100%' }}
                    >
                      <Input placeholder="Verification Code" maxLength={6} />
                    </Form.Item>

                    <Image 
                      className={styles['verification-image']}
                      alt="Verification Code"
                      width={'125'}
                      height={'30'}
                      onClick={generateCaptchaImage}
                      src={captcha.img} />

                  </div>
                }

                <Form.Item style={{ marginBottom: 0 }}>
                  <Button 
                    className={styles['save-btn']}
                    htmlType="submit"
                  >
                    Reset Password
                  </Button>
                </Form.Item>
                
              </Form>

              <div className={styles['back-to-sign']}>
                Back to
                <Link
                  href={'/login'}
                  legacyBehavior
                >
                  <a className={styles['link']} rel="noopener noreferrer">Sign in</a>
                </Link>
              </div>
            </div>
          }

        </div>
      </LoginLayout>
    </>
  )
}